import React, { FC, ReactNode } from "react";

export type FormControlProps = Record<string, unknown>;

interface FormFieldBoxProps {
  label: string;
  children: ReactNode | ((formControlProps: FormControlProps) => ReactNode);
}

export const FormFieldBox: FC<FormFieldBoxProps> = ({ label, children, ...rest }) => {
  const content = typeof children === "function" ? children(rest as FormControlProps) : children;
  return (
    <div className="name-field-2">
      <label className="form-label-style">{label}</label>
      {content}
    </div>
  );
};
